export const CORE_PATH = '/core/api';
export const DOC_PATH = '/doc/api';
export const EAR_PATH = '/ear/api';
